import { graphql } from 'gatsby';
import React from 'react';

interface SingleProps {
  css_class_name: string;
}

interface PlatformBlock extends SingleProps {
  _template: string;
  settings: {
    css_class_name: string;
  };
  title: string;
  cols: string;
  developer_cards?: boolean;
  cards: PlatformCard[];
}

type PlatformCard = {
  title: string;
  text: string;
  cta_text: string;
  cta_url: string;
  image: string;
  image_alt_text: string;
};

type PlatformProps = {
  block: PlatformBlock;
};

const PlatformCards: React.FC<PlatformProps> = ({ block }) => {
  let colsClass = '';
  if (typeof block.cols === 'string' && block.cols.length > 0) {
    colsClass = `col-lg-${12 / Number(block.cols)} col-md-6 col-12`;
  }
  const isDeveloperCard = block.developer_cards || false;

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <div className='row'>
          {block.cards.map((card, index) => (
            <div
              key={card.title}
              className={`card-item-wrapper ${colsClass} ${isDeveloperCard ? 'md:pb-4' : ''}`}
            >
              <PlatformCardItem
                data={card}
                isDeveloperCard={isDeveloperCard}
                index={index}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const PlatformCardItem: React.FC<{
  data: PlatformCard;
  isDeveloperCard?: boolean;
  index: number;
}> = ({ data, isDeveloperCard, index }) => {
  return (
    <>
      {isDeveloperCard ? (
        <div
          className={`card-item ${isDeveloperCard ? 'developer-card' : ''} ${index > 0 ? 'md:mt-4' : ''}`}
        >
          <PlatformCardInner
            data={data}
            isDeveloperCard={isDeveloperCard || false}
          />
        </div>
      ) : (
        <a
          className={`card-item ${isDeveloperCard ? 'developer-card' : ''}`}
          href={data.cta_url}
        >
          <PlatformCardInner
            data={data}
            isDeveloperCard={isDeveloperCard || false}
          />
        </a>
      )}
    </>
  );
};

function PlatformCardInner({
  data,
  isDeveloperCard,
}: {
  data: PlatformCard;
  isDeveloperCard: boolean;
}) {
  return (
    <>
      <div className='card-item__content'>
        <h4 className='card-item__title'>{data.title}</h4>
        <p
          className='card-item__text'
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
        {data.cta_text && isDeveloperCard && (
          <a
            href={data.cta_url}
            className='cta cta--compact cta-secondary mt-3 w-full !max-w-[200px] !px-[20px] !py-[10px]'
          >
            {data.cta_text}
          </a>
        )}
        {data.cta_text && !isDeveloperCard && (
          <div className='card-content__link'>{data.cta_text}</div>
        )}
      </div>
      <img
        className='card-item__image'
        src={data.image}
        alt={data.image_alt_text}
      />
    </>
  );
}

export default PlatformCards;

export const platformCardsFragment = graphql`
  fragment PlatformCardsFragment on Block {
    cards {
      title
      text
      cta_text
      cta_url
      image
      image_alt_text
    }
  }
`;
